import React, { useState, useRef } from "react";
import Stagiaire from "../../services/Stagiaire";
import Loader from "../../components/Loader";
import PopupAlert from "../../components/PopupAlert/PopupAlert";

function PostulerStage() {
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
    typestage: "",
    niveau: "",
    cv: null,
    lettre: null,
    cni: null,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState(null);
  const [alert, setAlert] = useState(null);

  const cvInputRef = useRef(null);
  const lettreInputRef = useRef(null);
  const cniInputRef = useRef(null);
  const stagiaireService = new Stagiaire();

  const triggerAlert = (type, message) => {
    setAlert({ type, message });
    setTimeout(() => setAlert(null), 10000);
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleFileClick = (ref) => {
    ref.current.click();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors({});
    setSuccessMessage(null);

    try {
      const formDataToSubmit = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null) {
          formDataToSubmit.append(key, value);
        }
      });

      const response = await stagiaireService.postuler(formDataToSubmit);

      if (response && response.status === true) {
        setSuccessMessage("Votre candidature a été envoyée avec succès !");
        triggerAlert("success", "Votre candidature a été envoyée avec succès !");
        setFormData({
          nom: "",
          prenom: "",
          email: "",
          telephone: "",
          typestage: "",
          niveau: "",
          cv: null,
          lettre: null,
          cni: null,
        });
        if (cvInputRef.current) cvInputRef.current.value = "";
        if (lettreInputRef.current) lettreInputRef.current.value = "";
        if (cniInputRef.current) cniInputRef.current.value = "";
      } else if (response?.errors) {
        setErrors(response.errors);
      }
    } catch (error) {
      const errorData = error.cause;
      if (errorData?.errors) {
        setErrors(errorData.errors);
        triggerAlert("error", "Veuillez corriger les erreurs dans le formulaire.");
      } else {
        triggerAlert("error", errorData?.message || "Une erreur est survenue. Veuillez réessayer.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="form-contact card mt-4 shadow-sm">
        <div className="card-body">
          <h2>Postuler pour un Stage</h2>
          <p className="text-muted mb-4">
            Remplissez le formulaire ci-dessous pour envoyer votre candidature.
          </p>

          {successMessage && <p className="text-success">{successMessage}</p>}

          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="form-contain col-md-6">
                <label htmlFor="nom">
                  Nom <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="nom"
                  name="nom"
                  placeholder="Votre nom"
                  className="form-control"
                  value={formData.nom}
                  onChange={handleChange}
                  required
                />
                {errors.nom && <small className="text-danger">{errors.nom[0]}</small>}
              </div>

              <div className="form-contain col-md-6">
                <label htmlFor="prenom">
                  Prénom <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="prenom"
                  name="prenom"
                  placeholder="Votre prénom"
                  className="form-control"
                  value={formData.prenom}
                  onChange={handleChange}
                  required
                />
                {errors.prenom && <small className="text-danger">{errors.prenom[0]}</small>}
              </div>

              <div className="form-contain col-md-6">
                <label htmlFor="email">
                  Adresse Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="votre@email.com"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && <small className="text-danger">{errors.email[0]}</small>}
              </div>

              <div className="form-contain col-md-6">
                <label htmlFor="telephone">Téléphone</label>
                <input
                  type="tel"
                  id="telephone"
                  name="telephone"
                  placeholder="+237xxxxxxxx"
                  className="form-control"
                  value={formData.telephone}
                  onChange={handleChange}
                />
                {errors.telephone && <small className="text-danger">{errors.telephone[0]}</small>}
              </div>

              <div className="form-contain col-md-6">
                <label htmlFor="typestage">
                  Type de stage <span className="text-danger">*</span>
                </label>
                <select
                  id="typestage"
                  name="typestage"
                  className="form-control"
                  value={formData.typestage}
                  onChange={handleChange}
                  required
                >
                  <option value="">Sélectionnez le type de stage</option>
                  <option value="observation">Stage d'observation</option>
                  <option value="pratique">Stage pratique</option>
                  <option value="perfectionnement">Stage de perfectionnement</option>
                  <option value="fin_etudes">Stage de fin d'études</option>
                  <option value="alternance">Alternance</option>
                </select>
                {errors.typestage && <small className="text-danger">{errors.typestage[0]}</small>}
              </div>

              <div className="form-contain col-md-6">
                <label htmlFor="niveau">
                  Niveau d'études <span className="text-danger">*</span>
                </label>
                <select
                  id="niveau"
                  name="niveau"
                  className="form-control"
                  value={formData.niveau}
                  onChange={handleChange}
                  required
                >
                  <option value="">Sélectionnez votre niveau</option>
                  <option value="bac">Baccalauréat</option>
                  <option value="bac+1">Bac+1</option>
                  <option value="bac+2">Bac+2</option>
                  <option value="bac+3">Licence / Bac+3</option>
                  <option value="bac+4">Master 1 / Bac+4</option>
                  <option value="bac+5">Master 2 / Bac+5</option>
                  <option value="doctorat">Doctorat</option>
                </select>
                {errors.niveau && <small className="text-danger">{errors.niveau[0]}</small>}
              </div>
            </div>

            <div className="row g-3 mt-1">
              <div className="form-contain col-md-4">
                <label htmlFor="cv">
                  CV <span className="text-danger">*</span>
                  <small className="text-muted d-block">(pdf, doc, docx)</small>
                </label>
                <input
                  type="file"
                  id="cv"
                  name="cv"
                  className="form-control"
                  ref={cvInputRef}
                  style={{ display: "none" }}
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  onClick={() => handleFileClick(cvInputRef)}
                  className="btn btn-outline-secondary btn-sm"
                >
                  <i className="fa-solid fa-upload me-1"></i>
                  Télécharger CV
                </button>
                {formData.cv && (
                  <p className="mt-2 mb-0 text-success">
                    <i className="fa-solid fa-check me-1"></i>
                    {formData.cv.name}
                  </p>
                )}
                {errors.cv && <small className="text-danger">{errors.cv[0]}</small>}
              </div>

              <div className="form-contain col-md-4">
                <label htmlFor="lettre">
                  Lettre de motivation <span className="text-danger">*</span>
                  <small className="text-muted d-block">(pdf, doc, docx)</small>
                </label>
                <input
                  type="file"
                  id="lettre"
                  name="lettre"
                  className="form-control"
                  ref={lettreInputRef}
                  style={{ display: "none" }}
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  onClick={() => handleFileClick(lettreInputRef)}
                  className="btn btn-outline-secondary btn-sm"
                >
                  <i className="fa-solid fa-upload me-1"></i>
                  Télécharger lettre
                </button>
                {formData.lettre && (
                  <p className="mt-2 mb-0 text-success">
                    <i className="fa-solid fa-check me-1"></i>
                    {formData.lettre.name}
                  </p>
                )}
                {errors.lettre && <small className="text-danger">{errors.lettre[0]}</small>}
              </div>

              <div className="form-contain col-md-4">
                <label htmlFor="cni">
                  Copie CNI <span className="text-danger">*</span>
                  <small className="text-muted d-block">(pdf uniquement)</small>
                </label>
                <input
                  type="file"
                  id="cni"
                  name="cni"
                  className="form-control"
                  ref={cniInputRef}
                  style={{ display: "none" }}
                  accept=".pdf"
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  onClick={() => handleFileClick(cniInputRef)}
                  className="btn btn-outline-secondary btn-sm"
                >
                  <i className="fa-solid fa-upload me-1"></i>
                  Télécharger CNI
                </button>
                {formData.cni && (
                  <p className="mt-2 mb-0 text-success">
                    <i className="fa-solid fa-check me-1"></i>
                    {formData.cni.name}
                  </p>
                )}
                {errors.cni && <small className="text-danger">{errors.cni[0]}</small>}
              </div>
            </div>

            <button
              type="submit"
              className={`btn-submit mt-4 ${isSubmitting ? "disabled" : ""}`}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Loader width={20} height={20} /> Envoi en cours...
                </>
              ) : (
                "Envoyer ma candidature"
              )}
            </button>
          </form>
        </div>
      </div>

      {alert && (
        <PopupAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
}

export default PostulerStage;